import React, { useState } from 'react'
import {
  Box, Button, Chip, InputAdornment, TextField, Typography, makeStyles,
} from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import AddIcon from '@material-ui/icons/Add'
import Layout from '../../components/layout/Layout'
import PaymentAttemptsPanel from '../../components/admin/PaymentAttemptsPanel'
import AddPremiumUserDialog from '../../components/admin/AddPremiumUserDialog'
import BillingByOrgCards from '../../components/admin/BillingByOrgCards'
import ContractorsPayments from './ContractorsPayments'

const useStyles = makeStyles((theme) => ({
  root: { fontFamily: 'Vazir' },
  head: {
    display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 10,
    marginBottom: 12,
  },
  title: { fontWeight: 800, fontSize: 18, color: '#1a237e' },
  filters: {
    display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 8,
    background: '#fff', border: '1px solid #e6e9f6', borderRadius: 14,
    padding: '10px 12px', marginBottom: 12,
  },
  pills: { display: 'flex', gap: 6, flexWrap: 'wrap' },
  pill: {
    cursor: 'pointer', fontSize: 12, fontWeight: 700, borderRadius: 999,
    padding: '4px 12px', background: '#eef1ff', color: '#283593',
    whiteSpace: 'nowrap',
  },
  pillOn: { background: '#1a237e', color: '#fff' },
  tabs: {
    display: 'flex', gap: 6, overflowX: 'auto', paddingBottom: 4, marginBottom: 12,
    WebkitOverflowScrolling: 'touch',
  },
  tab: {
    cursor: 'pointer', fontSize: 12.5, fontWeight: 800, borderRadius: 10,
    padding: '8px 14px', background: '#f1f5f9', color: '#334155',
    whiteSpace: 'nowrap', border: '1px solid #e2e8f0',
  },
  tabOn: { background: '#1a237e', color: '#fff', borderColor: '#1a237e' },
  search: { flex: 1, minWidth: 220 },
  hint: { fontSize: 11.5, color: '#7a80a3' },
}))

const PERIODS = [
  { code: '1m', title: 'یک ماه' },
  { code: '3m', title: 'سه ماه' },
  { code: '6m', title: 'شش ماه' },
  { code: '1y', title: 'یک سال' },
  { code: 'all', title: 'همه' },
]

const TABS = [
  { key: 'contractors', title: 'پیمانکاران و اشتراک' },
  { key: 'attempts', title: 'اقدام‌های پرداخت' },
]

// بازهٔ انتخابی ⇒ تعداد روز برای API
const PERIOD_DAYS = { '1m': 30, '3m': 90, '6m': 180, '1y': 365, all: 3650 }

export default function Billing() {
  const classes = useStyles()
  const [tab, setTab] = useState('contractors')
  const [period, setPeriod] = useState('1y')
  const [q, setQ] = useState('')
  const [premiumOpen, setPremiumOpen] = useState(false)
  const [refreshKey, setRefreshKey] = useState(0)

  return (
    <Layout title="مالی و اشتراک‌ها">
      <Box className={classes.root} p={2}>
        <Box className={classes.head}>
          <Typography className={classes.title}>مرکز مالی و اشتراک‌ها</Typography>
          <Typography className={classes.hint}>
            اشتراک پیمانکاران و اقدام‌های پرداخت — یک‌جا
          </Typography>
          <Box style={{ flex: 1 }} />
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={() => setPremiumOpen(true)}
            style={{ fontWeight: 800, textTransform: 'none' }}
          >
            افزودن کاربر ویژه
          </Button>
        </Box>

        <Box className={classes.filters}>
          <Typography style={{ fontSize: 12, color: '#607d8b', fontWeight: 800 }}>بازه:</Typography>
          <Box className={classes.pills}>
            {PERIODS.map((p) => (
              <span
                key={p.code}
                className={`${classes.pill} ${period === p.code ? classes.pillOn : ''}`}
                onClick={() => setPeriod(p.code)}
              >
                {p.title}
              </span>
            ))}
          </Box>
          <TextField
            className={classes.search}
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="جستجوی نام، موبایل یا شناسه ملی…"
            variant="outlined"
            size="small"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" style={{ color: '#90a4ae' }} />
                </InputAdornment>
              ),
            }}
          />
        </Box>

        <Box className={classes.tabs}>
          {TABS.map((t) => (
            <span
              key={t.key}
              className={`${classes.tab} ${tab === t.key ? classes.tabOn : ''}`}
              onClick={() => setTab(t.key)}
            >
              {t.title}
            </span>
          ))}
        </Box>

        {tab === 'contractors' && (
          <>
            <BillingByOrgCards days={PERIOD_DAYS[period] || 365} />
            <ContractorsPayments key={refreshKey} embedded period={period} search={q} />
          </>
        )}

        {tab === 'attempts' && <PaymentAttemptsPanel />}

        <AddPremiumUserDialog
          open={premiumOpen}
          onClose={() => setPremiumOpen(false)}
          onCreated={() => setRefreshKey((k) => k + 1)}
        />
      </Box>
    </Layout>
  )
}
